export default "__VITE_ASSET__D8ue7ISw__"